export default __webpack_public_path__ + "static/media/Filter_By_Class_Icon_orange.3b830469.svg";